module.exports = __webpack_public_path__ + "static/bg-reply-logistics-89d19f82d5a66feb36a7d54f48e66a0d.webp";